export default "__VITE_ASSET__Dsyr6bw5__"